{
  "meterMulti": {
    "analogCalibration": "Calibration settings for an analog (needle) meter. To change the reading area or the scale's minimum and maximum, recalibrate in God and verify with the CPU image test.",
    "x": "Left edge of the area (ratio of image width, where width = 1)",
    "y": "Top edge of the area (ratio of image height, where height = 1)",
    "w": "Width of the area (ratio of image width, where width = 1)",
    "h": "Height of the area (ratio of image height, where height = 1)",
    "unfixedDecimal": "Don't fix the decimal point position",
    "conditionExample": "Example: greater than 23, 20 or less",
    "refresh": "Reload image",
    "wholeImage": "Whole image (with reading areas)",
    "image": "Image to read",
    "item": "Reading item {{number}}",
    "label": "Item name",
    "roi": "Edit area on image",
    "conditionReference": "This item is used by a threshold condition. Change the condition's target before deleting it.",
    "remove": "Delete item",
    "add": "Add reading item",
    "mode": "Reading format",
    "multi": "Multiple items (no unit)",
    "single": "Single item (legacy)",
    "conditionField": "Threshold condition item",
    "edit": "Edit reading items"
  },
  "meterCreate": {
    "title": "Add meter detection",
    "create": "Create as disabled",
    "camera": "Target camera",
    "name": "Detection name",
    "unit": "Unit",
    "width": "Source image width (px)",
    "height": "Source image height (px)",
    "x": "Reading area left edge (px)",
    "y": "Reading area top edge (px)",
    "w": "Reading area width (px)",
    "h": "Reading area height (px)",
    "digits": "Number of digits (excluding sign and decimal point)",
    "decimals": "Decimal places",
    "confidence": "Minimum confidence (0–1)",
    "minimum": "Minimum reading value",
    "maximum": "Maximum reading value",
    "stale": "Image validity period (seconds)",
    "guidance": "A single detection can register multiple items read from the same image. Notifications are disabled. After creation, an administrator enables the detection on the target camera in God, checks the values with an image test, and then resumes dedicated processing.",
    "validation": "Fill in all fields. The area must be within the source image, decimal places must be fewer than the number of digits, and the minimum must be less than or equal to the maximum.",
    "noCameras": "No target cameras are available to manage. Check your permissions and camera settings.",
    "error": "The detection couldn't be created. Check the input and your permissions."
  },
  "aiDetectionActionMenu": {
    "label": "Delete with data",
    "ariaLabel": "Detection menu"
  },
  "aiDetectionCard": {
    "text": "Latest result",
    "text2": "View details",
    "text3": "{{value}} detection",
    "text4": "View readings in the details",
    "text5": "Readings"
  },
  "aiDetectionDeleteDialog": {
    "title": "Delete detection data",
    "text": " will be deleted along with its data. Continue?",
    "text2": "Once deleted, it can no longer be viewed in the list or details."
  },
  "aiDetectionDetailPage": {
    "csvCameraLabel": "All permitted target cameras",
    "label": "All",
    "label2": "Unreviewed",
    "label3": "True positive",
    "label4": "False positive",
    "usePageTitle": "AI detection events",
    "label5": "Detected at",
    "label6": "Camera",
    "label7": "Result",
    "enqueueSnackbar": "The CSV export start and end date and time are invalid.",
    "text": "Not applicable",
    "enqueueSnackbar3": "This detection event doesn't support review.",
    "enqueueSnackbar4": "Viewing reviews isn't permitted.",
    "enqueueSnackbar5": "Review saved",
    "enqueueSnackbar6": "No detection images are available.",
    "enqueueSnackbar7": "The camera information needed to open the viewer couldn't be retrieved.",
    "text2": "Searching detection events... ({{value}} checked)",
    "text3": "The detection event search failed.",
    "text4": "No matching detection events",
    "text5": "Check detection result",
    "text6": "View video",
    "text7": "An error occurred.",
    "alert": "This AI detection was stopped because its camera moved to another area. Its settings can't be changed or deleted, but detection data from before it stopped is still available.",
    "label8": "Start date and time",
    "label9": "End date and time",
    "placeholder": "Search by camera name or detection result",
    "label10": "Judgment",
    "text8": "Exporting CSV... ({{value}})",
    "text9": "Download CSV",
    "label11": "Hide false positives",
    "imageAlt": "AI detection result",
    "text10": "AI detection result {{previewEventDate}}",
    "text11": "The revision history couldn't be retrieved.",
    "text12": "Additional revision history couldn't be retrieved.",
    "text13": "The latest review status couldn't be retrieved.",
    "error": "The CSV export took longer than 5 minutes. Shorten the period and try again. No CSV was exported.",
    "enqueueSnackbar8": "CSV export was canceled. No CSV was exported.",
    "enqueueSnackbar9": "The CSV download failed.",
    "button": "Cancel CSV export",
    "text14": "No period limit",
    "text15": "Exports up to {{value}} latest records (no period limit)",
    "csvTruncatedNotice": "Only the latest {{value}} records were exported because of the limit. The export isn't complete.",
    "text16": "No readings in the retrieved range. You can load the next period.",
    "text17": "No matching readings",
    "button2": "Load more readings",
    "button3": "Missed object reports and image corrections",
    "backToList": "Back to list"
  },
  "aiDetectionEditorDialog": {
    "text": "Every {{seconds}} sec",
    "text2": "Every {{value}} min",
    "text3": "Every {{value}} hr",
    "text4": "Once a day",
    "text5": "Enter a detection title.",
    "text6": "The detection title must be 10 characters or fewer.",
    "text7": "Select a target camera.",
    "text8": "Only cameras with AI detection turned on can be selected.",
    "text9": "Enter a detection target.",
    "text10": "Enter a detection condition.",
    "text11": "Enter a detection condition count.",
    "text12": "The detection condition count must be 1 or greater.",
    "text13": "Enter a detection start date and time.",
    "text14": "Enter a detection end date and time.",
    "text15": "The detection end date and time must be on or after the start date and time.",
    "text16": "Set a detection schedule.",
    "setErrorMessage": "The area of the target camera couldn't be determined.",
    "text17": "The detection condition couldn't be saved.",
    "text18": "Custom detection",
    "text19": "Preset detection",
    "label": "Detection title (up to 10 characters)",
    "label2": "Detection type",
    "menuItem": "People count",
    "menuItem2": "No helmet",
    "label3": "Condition count (people count only)",
    "label4": "Comparison",
    "menuItem3": "Or more",
    "menuItem4": "More than",
    "text20": "Target cameras",
    "text21": "Custom",
    "text22": "Preset",
    "text23": " detection limits follow each camera's setting",
    "text24": "No cameras have AI detection turned on",
    "label5": "{{name}} ({{value}} detections {{usageCount}}/{{value2}})",
    "label6": "Detection area",
    "menuItem5": "Off",
    "menuItem6": "On (set area in Viewer)",
    "text25": "Available only when a target camera is selected",
    "label7": "Detection start date and time",
    "label8": "Detection end date and time",
    "label9": "No end date",
    "label10": "Detection time",
    "menuItem7": "All day",
    "menuItem8": "Specify time range",
    "menuItem9": "Specify schedule",
    "label11": "Detection start time",
    "label12": "Detection end time",
    "button": "Edit",
    "label13": "Notification email recipients",
    "label14": "Notes",
    "text26": "Detection frequency: ",
    "text27": " (can't be changed when copying)",
    "label15": "Detection frequency",
    "text28": "Detection frequency: every 5 sec",
    "button2": "Run",
    "text29": "Custom",
    "text30": "Preset"
  },
  "aiDetectionEventCard": {
    "text": "View video",
    "text2": "Enlarge AI detection result image",
    "text3": "No result",
    "text4": "Review",
    "text5": "View history"
  },
  "aiDetectionEventTable": {
    "text": "View video",
    "label": "Detected at",
    "label2": "Detection result",
    "text2": "No result",
    "label3": "Review status",
    "text3": "Not applicable",
    "label4": "Actions",
    "text4": "Review",
    "text5": "View history"
  },
  "aiDetectionListPage": {
    "label": "All",
    "label2": "Custom",
    "label3": "All",
    "label4": "Detecting",
    "label5": "Stopped",
    "enqueueSnackbar": "The item to delete couldn't be retrieved.",
    "enqueueSnackbar2": "AI detection history for a moved camera can't be deleted.",
    "enqueueSnackbar3": "{{value}} and its data were deleted",
    "text": "An error occurred.",
    "placeholder": "Search by camera, area, or detection name",
    "button": "Filter",
    "label8": "Detection type",
    "label9": "Area / camera"
  },
  "aiDetectionListTable": {
    "label": "Latest result",
    "label2": "Detection settings",
    "label3": "Type",
    "label4": "Status",
    "label5": "Last detected at",
    "label6": "Area / camera",
    "label7": "Readings",
    "text": "View readings in the details"
  },
  "aiDetectionNotificationDialog": {
    "setErrorMessage": "The notification recipients couldn't be updated.",
    "text": "Change notification recipients",
    "text2": ": enter the notification email addresses.",
    "label": "Notification email recipients"
  },
  "aiDetectionReviewDialog": {
    "label": "Mark as unreviewed",
    "label2": "Mark as true positive",
    "label3": "Mark as false positive",
    "text": "The save key is being used by another update. Check the content and save again.",
    "text2": "The same item was updated by another user. Check the latest status and save again.",
    "text3": "The review couldn't be saved. Your input is kept, so you can try again.",
    "text4": "Unknown date",
    "text5": "Judgment changed",
    "text6": "Result corrected",
    "text7": "Reverted to AI original",
    "text8": "Judgment and result changed",
    "text9": "Review updated",
    "text10": "Review updated ({{action}})",
    "text11": "Saving...",
    "title": "Review AI detection result",
    "alert": "The review can't be displayed because the detection event can't be uniquely identified.",
    "alert2": "This detection result doesn't support manual review yet.",
    "text12": "Detected at",
    "alt": "Detection image under review",
    "text13": "The detection image can't be displayed.",
    "text14": "No detection image",
    "text15": "Saved review status",
    "alert3": "This detection result is view-only. Judging or correcting it isn't permitted.",
    "text16": "Apply latest status",
    "text17": "Apply latest status and retry",
    "text18": "Conflicting items:",
    "text19": "AI-generated original text",
    "text20": "No result",
    "ariaLabel": "Judgment status",
    "text21": "Judgment",
    "alert4": "Saving as a false positive hides this detection result in the Viewer. In Admin, it can be shown again with a filter.",
    "label4": "Corrected result",
    "label5": "Comment (optional)",
    "text22": "Hide revision history",
    "text23": "View revision history",
    "ariaLabel2": "Loading revision history",
    "text24": "No revision history",
    "text25": "Unknown user",
    "text26": "Comment:",
    "text27": "Loading history...",
    "text28": "Load more",
    "button": "Edit detection boxes"
  },
  "expandableResultText": {
    "text": "Show more"
  },
  "aiDetectionCsv": {
    "text5": "Detected at",
    "text6": "Raw result",
    "text7": "Review status",
    "text8": "Status",
    "text9": "Camera name",
    "text10": "Detection result",
    "text11": "Observed at",
    "text12": "Value",
    "text13": "Unit",
    "text14": "OCR text",
    "text15": "Confidence",
    "text16": "Validation result",
    "text17": "Rejection reason",
    "push": "\r\n{{value}}",
    "error": "The CSV export period is invalid.",
    "text18": "Accepted",
    "text19": "Rejected"
  },
  "aiDetectionReview": {
    "text": "True positive",
    "text2": "False positive",
    "text3": "Unreviewed",
    "text4": "Judgment",
    "text5": "Corrected result",
    "text6": "Other changes",
    "text7": "Other ({{normalizedField}})",
    "text8": "None",
    "text9": "Unknown judgment ({{value}})",
    "text10": "AI original (not corrected)",
    "text11": "Empty",
    "errorMessage": "Enter the corrected result."
  },
  "aiDetectionStopDialog": {
    "text": "Stopping...",
    "text2": "Stop",
    "title": "Stop detection",
    "text3": " will be stopped. Continue?"
  },
  "aiDetectionWeeklyScheduleDialog": {
    "label": "Confirm",
    "title": "Edit detection schedule",
    "text": "Drag to select or clear time slots",
    "label2": "{{label}} {{value}}-{{value2}}"
  },
  "meterEventConditionDialog": {
    "title": "Meter detection conditions",
    "loadError": "The detection conditions can't be retrieved.",
    "loading": "Loading",
    "locked": "Conditions can't be changed while dedicated processing is running. An administrator must stop dedicated processing, change the conditions, and then revalidate and resume it.",
    "saveError": "The conditions couldn't be saved. Check the conditions and your permissions.",
    "guidance": "Evaluates thresholds against existing numeric readings. Change conditions only after dedicated processing is stopped; an administrator must then revalidate and resume it. External notification settings aren't changed.",
    "saved": "Detection conditions saved. Resume dedicated processing after revalidation.",
    "enabled": "Enable threshold events",
    "example": "Example: working radius exceeds 25 m, temperature is 30°C or higher. Enter one comparison with a unit.",
    "ongoing": "Save and show ongoing threshold events",
    "ongoingHelp": "Numeric history is always shown separately. Ongoing events don't add notifications or start pins on the seek bar.",
    "compiled": "Saved comparison: reading {{operator}} {{threshold}}"
  },
  "meterResults": {
    "readings": "Numeric history",
    "events": "Threshold events",
    "edit": "Edit detection conditions"
  },
  "aiDetectionCsvExportControls": {
    "analysisCsv": "Analysis CSV",
    "analysisTitle": "Generate analysis CSV",
    "modeLabel": "Analysis method",
    "refineryMode": "Corrected raw data (Refinery v2)",
    "analyzerMode": "Crane lift analysis (Analyzer v2.1)",
    "publishedMode": "Configured analysis method",
    "unknownMode": "Unsupported analysis method",
    "modeUnavailable": "No analysis method is available. Check the published settings.",
    "generate": "Generate",
    "generating": "Submitting…",
    "refinedCsv": "Corrected CSV",
    "correctionCsv": "Numeric correction history CSV",
    "emptyRefined": "The corrected output has 0 rows. Check the numeric correction history CSV.",
    "refinedDownload": "Download corrected CSV",
    "outputRows": "{{value}} output rows",
    "alert": "The aggregated CSV settings can't be checked.",
    "cameraLabel": "Camera to export",
    "button": "Recheck",
    "button3": "Generation history",
    "historyError": "The CSV generation status can't be retrieved.",
    "historyTruncated": "The generation status above is unknown because this camera has no generation history in the last 100 jobs.",
    "running": "Generating CSV",
    "completed": "CSV generated",
    "failed": "CSV generation failed. No partial CSV is available.",
    "summaryRows": "Summary: {{value}} rows",
    "summaryDownload": "Download summary CSV",
    "linkRetry": "Get download link again",
    "summaryUnavailable": "The summary CSV isn't available. Check the generation history.",
    "settingChanged": "The published configuration has changed. Select the output skill again.",
    "createFailed": "The CSV generation request wasn't accepted. Try again.",
    "semanticNotice": "The analysis CSV includes additional AI processing. Selecting Generate uses an estimated cost limit of USD {{value}} and condition version {{revision}}.",
    "skillLabel": "Output skill",
    "skillCamera": "Camera: {{camera}}",
    "analyzerV22Mode": "Crane lift analysis (Analyzer v2.2)",
    "cyclesCsv": "Lift cycle CSV",
    "phasesCsv": "Phase CSV",
    "timelineCsv": "Audit time-series CSV",
    "analyzerV24Mode": "Crane lift analysis (Analyzer v2.4)",
    "exclusionsCsv": "Unparsed row exclusion history CSV",
    "lowLoadCsv": "Low-load decision history CSV",
    "processingCsv": "Processing summary CSV",
    "timelineV24Csv": "5-second audit time-series CSV"
  },
  "aiDetectionCsvExportDialog": {
    "unsupportedSource": "This input data isn't supported or isn't permitted by the published settings. Check the CSV export settings in God.",
    "text": "Generate aggregated and analyzed CSV",
    "alert": "All records matching the conditions below are included, not just the current page. If the row limit is exceeded, an error occurs instead of truncating the output. Once accepted, processing continues even if you close this screen.",
    "text3": "Display period (including the end minute):",
    "text4": "Includes the start minute through the end minute. The API end boundary is the start of the next minute (exclusive). The maximum period is 31 days. API end boundary:",
    "text5": "Output time zone:",
    "text6": "Target cameras:",
    "text7": "Input data:",
    "text8": "Search:",
    "text9": "None",
    "text10": "Judgment:",
    "text11": "Status:",
    "text12": "/ Archived:",
    "text13": "Included",
    "text14": "Excluded",
    "text15": "Output columns:",
    "text16": "Summary limit:",
    "text17": " rows / Input limit:",
    "text18": " records / Audit limit:",
    "text19": " rows",
    "text20": "Permissions and the published version are rechecked at run time. Formulas are edited in God.",
    "alert2": "This setting uses detection events saved on state changes, not the meter observation list. Observations every 5 seconds aren't guaranteed. Review conditions for meter observations aren't carried over.",
    "button": "Review condition changes and switch to continuous numeric observations",
    "label": "I've checked the target data, conditions, published version, and limits",
    "button2": "Cancel",
    "text21": "Submitting…",
    "text22": "Generate with these conditions"
  },
  "aiDetectionCsvExportHistory": {
    "text": "Aggregated and analyzed CSV generation history",
    "text2": "History of CSVs you requested from Analysis CSV for this detection. Each CSV is generated with the period, conditions, and CSV export settings at the time of the request.",
    "text3": "Loading generation history…",
    "alert": "The generation history couldn't be retrieved.",
    "button": "Retry",
    "text4": "No generation history.",
    "text6": "Requested",
    "text8": "Period",
    "text9": " (end exclusive) /",
    "text10": "Search:",
    "text11": "None",
    "text12": "/ Cameras:",
    "text13": "All permitted target cameras",
    "cameraCount": "{{value}} cameras",
    "text14": "Input",
    "text15": "Pending",
    "text16": " records → Summary",
    "text17": " rows / Audit",
    "text18": " rows",
    "text19": "Expires:",
    "alert2": "Generation failed:",
    "alert3": ". No partial CSV was exported.",
    "text20": "Summary CSV",
    "text21": "Audit CSV",
    "text22": "Run info JSON",
    "button2": "Cancel generation",
    "button3": "Retry",
    "alert4": "Download failed:",
    "button4": "Latest history",
    "button5": "Next",
    "text23": "Retry with the same conditions?",
    "text24": "Cancel generation?",
    "text25": "Runs again with the same published version and conditions. Additional processing costs may apply.",
    "text26": "After canceling, the CSV from this run can't be retrieved. If it has already completed, check the result again.",
    "text27": "The cost conditions fixed for this job are used. It isn't switched to the current published settings.",
    "text28": "Check cost and retry",
    "text29": "Cancel generation",
    "phaseRows": " rows → phases",
    "timelineRows": " rows / 5-second timeline"
  },
  "csvSemanticCostConfirmation": {
    "alert": "This export includes AI classification and extraction, which incur processing costs in addition to normal calculation. Processing stops if the limit is exceeded.",
    "text": "Estimated cost limit for additional AI processing: USD",
    "text2": "/ Cost condition version:",
    "label": "I've checked the cost limit and condition version for additional AI processing"
  },
  "aiAnnotationEditor": {
    "error": "The image capture time can't be verified.",
    "error2": "The source image doesn't match. Export stopped.",
    "newAnnotation": "Target",
    "confirm": "Discard unsaved bounding box changes and close?",
    "text": "Edit missed objects",
    "text2": "Edit detection bounding boxes",
    "ariaLabel": "Preparing the source image",
    "alert": "The source image isn't available. Bounding boxes can't be saved.",
    "alert2": "Another user updated this image. Unsaved edits are preserved. Reload the latest bounding boxes and check them again.",
    "text3": "Unknown capture time",
    "text4": "/ Saved revision",
    "text5": "/ AI boxes: green, corrected boxes: orange",
    "button": "Add a box",
    "button2": "Delete selected box",
    "button3": "Undo",
    "button4": "Redo",
    "button5": "Restore AI boxes",
    "label": "Zoom",
    "menuItem": "×",
    "alt": "Pinned source image",
    "ariaLabel2": "Detection bounding box editor",
    "ariaLabel3": "Bounding box {{label}}",
    "ariaLabel4": "Resize box",
    "label2": "Selected box label",
    "label3": "Reason for correction (optional)",
    "label4": "I've checked the boxes and labels for inclusion in the training dataset",
    "label5": "I've confirmed that the image contains no target objects (negative example)",
    "button6": "Download corrected image",
    "button7": "Report a missed object in this image",
    "button8": "Correction history",
    "button9": "Export training dataset",
    "confirm2": "Discard unsaved edits and reload the latest bounding boxes?",
    "button10": "Reload latest boxes",
    "button11": "Save boxes",
    "text6": "Report a missed object",
    "text7": "Enter the object that should have been detected in this pinned image.",
    "label6": "Expected object",
    "button12": "Create report",
    "text8": "/ Edited by",
    "button13": "Load more",
    "text9": "Select confirmed images from the latest 50 items for this camera. Images, revisions, and labels are fixed for export.",
    "label7": "{{value}} / {{value2}} / {{value3}}",
    "label8": "Training classes (one per line; line order sets the class IDs)",
    "label9": "Export format",
    "button14": "Download ZIP"
  },
  "aiAnnotationReportsDialog": {
    "text": "Missed object reports and image corrections",
    "label": "Camera",
    "text2": "Reports without a detection event can be registered with a camera and capture time. Reports without images aren't included in training datasets.",
    "label2": "Capture time (this device's local time)",
    "label3": "Expected object",
    "label4": "Report details (optional)",
    "alert": "The missed object report was registered.",
    "button": "Register missed object report",
    "text3": "Latest 50 items for this camera",
    "text4": "Missed object",
    "text5": "Image correction",
    "button2": "Open image and boxes",
    "label5": "Pin the camera source image at this time (an error occurs if no image is available)"
  },
  "csvExportPresentation": {
    "emptySummary": "Input records exist, but no results meet the aggregation conditions in this period, so the summary has 0 rows. Check the records and judgment process in the audit CSV.",
    "noData": "No input records exist in the specified period. Check the date and time and the target cameras.",
    "legacySparse": "Check the observation interval of the source data. Continuous observations needed to determine work steps may be missing.",
    "continuityUnverified": "Completeness of continuous observations isn't guaranteed. Estimated work steps aren't final results.",
    "canonicalEventCsvProjection": "Times and states are formatted from detection events for this CSV. Their format may differ from the raw data CSV.",
    "correctedValuesEstimated": "Corrected values are estimates. Distinguish them from measured values and check the numeric correction history CSV for details.",
    "normalThresholdsUnset": "Normal correction conditions are not set for some fields. Candidates for those corrections are kept for review without automatic correction.",
    "otherWarning": "There are analysis notes. See the run info JSON for details.",
    "queued": "Queued",
    "collecting": "Collecting data",
    "analyzing": "Calculating and analyzing",
    "validating": "Validating output",
    "completed": "Completed",
    "failed": "Failed",
    "canceled": "Canceled",
    "expired": "Expired",
    "text": "The cost conditions for additional AI processing can't be checked. Reload the settings.",
    "text2": "The end date and time must be after the start date and time.",
    "text3": "The maximum period that can be processed at once is 31 days.",
    "error": "A secure download URL couldn't be retrieved.",
    "all": "All",
    "unreviewed": "Unreviewed",
    "truePositive": "True positive",
    "falsePositive": "False positive",
    "text4": "{{label}} (excluding false positives)",
    "text5": "Unknown date and time",
    "text6": "The display time zone is invalid.",
    "text7": "Detection events (on state change)",
    "text8": "Continuous numeric observations",
    "text9": "Unsupported input data",
    "text10": "Detection started",
    "text11": "Detection ended",
    "text12": "Ongoing",
    "text13": "Unsupported status",
    "estimatedCranePhases": "Work phases are estimated from observations. Check them against the actual work.",
    "provisionalCraneMotionThresholds": "Movement criteria are provisional. Verify the start and end of rotation and transport.",
    "unsetCraneWeightStability": "Weight stability criteria are not configured. Estimated weights require review.",
    "provisionalCraneWeightStability": "Load stability criteria are provisional. Check the estimated weight and the records used to calculate it.",
    "provisionalCraneRefineryThresholds": "Criteria for correcting swapped or incorrect readings are provisional. Check the numeric correction history.",
    "stateHoldEstimates": "Periods without updates are reconstructed by holding the previous value. Held values are estimates, not measurements.",
    "monitoringUnverified": "Continuous monitoring has not been verified. Long periods of held values may be indistinguishable from interrupted data collection.",
    "rotationUnsynchronized": "Rotation was not synchronized. Cabin monitor rotation values are used.",
    "lowLoadCorrected": "Temporary low loads were corrected for analysis to continue the same lift cycle. Check the low-load decision history CSV."
  }
}
